"use client";

import { useQuery } from '@tanstack/react-query'
import { getApi } from "@src/config/apiWithFetch"
import { URL_LISTING_IMAGES } from "@src/constant/api-url"
import { KEY_DETAIL_LISTING } from "@src/constant/query-keys/list-listing"

const getListingImages = async ({ queryKey }) => {
  const [_key, { requestUrl, params }] = queryKey;
  const res = await getApi(requestUrl, params);

  return res.data
}

export const useQueryGetListingImages = (slug) => {
  const dependencies = {
    requestUrl: URL_LISTING_IMAGES.replace(":slug", slug)
  }
  
  return useQuery({
    queryKey: [KEY_DETAIL_LISTING, dependencies],
    queryFn: getListingImages,
    enabled: !!slug
  })
}
